import has from 'lodash/has'
import Immutable, { ImmutableObjectMixin } from 'seamless-immutable'

// The transform runs on each persisted reducer's sub-state, not the root state.

// is this object already Immutable?
const isImmutable = (obj: object): obj is ImmutableObjectMixin<object> => has(obj, 'asMutable')

// change this Immutable object into a JS object
const convertToJs = (state: ImmutableObjectMixin<object>) => state.asMutable({ deep: true })

// optionally convert this object into a JS object if it is Immutable
const fromImmutable = (value: object) => (isImmutable(value) ? convertToJs(value) : value)

// convert this JS object into an Immutable object
const toImmutable = (raw: object) => Immutable(raw)

// the transform interface that redux-persist is expecting
export default {
  out: (state: object) => {
    return toImmutable(state)
  },
  in: (raw: object) => {
    return fromImmutable(raw)
  },
}
